import {PriceStrategy} from "app/components/inputs/price/input/PriceStrategy";

export class TradingIdeasIndexPriceFormatStrategy extends PriceStrategy {

    public static readonly Instance = new TradingIdeasIndexPriceFormatStrategy();

    private constructor() {
        super();
    }

    public format(input: any, skipInvalidValues: boolean): any {
        if (input == null) {
            return null;
        } else {
            return input.toFixed(0);
        }
    }

    public formatValueExtraPrecision(input: number | null, extraPrecision: number = 0): string | null {
        if (input == null) {
            return null;
        } else {
            return input.toFixed(extraPrecision);
        }
    }

    public formatValue(input: number | null): string | null {
        return this.format(input, false);
    }

    public formatStrike(input: number | null): string | null {
        return this.format(input, true);
    }

    public parse(input: any): any {
        throw Error("not implemented");
    }

    public stepSize(limit: number): number {
        throw Error("not implemented");
    }
}

export class TradingIdeasEquityPriceFormatStrategy extends PriceStrategy {

    public static readonly Instance = new TradingIdeasEquityPriceFormatStrategy();

    private constructor() {
        super();
    }

    public format(input: any, skipInvalidValues: boolean): any {
        if (input == null) {
            return null;
        } else {
            const rounded = input.toFixed(2);
            return `$${rounded}`;
        }
    }

    public formatValueExtraPrecision(input: number | null, extraPrecision: number = 0): string | null {
        if (input == null) {
            return null;
        } else {
            const rounded = input.toFixed(2 + extraPrecision);
            return `$${rounded}`;
        }
    }

    public formatValue(input: number | null): string | null {
        return this.format(input, false);
    }

    public formatStrike(input: number | null): string | null {
        if (input == null) {
            return null;
        } else {
            return input.toFixed(3);
        }
    }

    public parse(input: any): any {
        throw Error("not implemented");
    }

    public stepSize(limit: number): number {
        throw Error("not implemented");
    }
}
